module.exports = __webpack_public_path__ + "8ae3abd7608125428052b528fe3cabb4.png";